import { clientViewPartnerPortalPath } from "./clientViewPartnerPortalRoutes.js";
import { CASAMAPA_CLIENT_VIEW_SLUG } from "./casamapaPartnerPortalConfig.js";

/** Inventory workspace for an agency (partner portal). Per-agency /portal pages were removed. */
export function casamapaAgencyInventoryPath(agencySlug) {
  return clientViewPartnerPortalPath(
    CASAMAPA_CLIENT_VIEW_SLUG,
    `agencies/${encodeURIComponent(agencySlug)}/inventory`
  );
}

/**
 * @deprecated Use casamapaAgencyInventoryPath. Kept so older imports keep compiling;
 * resolves to inventory, not the removed /portal dashboard.
 */
export function casamapaAgencyPortalPath(agencySlug, segment = "") {
  if (!segment || segment === "inventory") {
    return casamapaAgencyInventoryPath(agencySlug);
  }
  if (segment === "leads") {
    return clientViewPartnerPortalPath(CASAMAPA_CLIENT_VIEW_SLUG, "leads");
  }
  return casamapaAgencyInventoryPath(agencySlug);
}

export function casamapaAgencyPortalBase(agencySlug) {
  return casamapaAgencyInventoryPath(agencySlug);
}
